import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // small delay so react-helmet-async has committed the page's <title> first
    const timer = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 50);
    return () => clearTimeout(timer);
  }, [location]);

  return null;
}
